import React, { useContext, useEffect } from 'react';
import AuthContext from '@cpg-its/ads.auth.auth-context';
import { useDispatch } from 'react-redux';
import { CpgAppSelect } from '../../cic/cic-app-dropdown';
import { CicAppContext, CicAppKeys } from '../../cic/cic-nav-context';
import { Navigation } from '../../global/models/navigation-model';
import { getApplications, getRoles } from '../../global/ducks/wam-api';
import { dispatchSetApplicationList, setAccessToken, setRoleObject, setRoles } from '../../global/ducks/authenticated-slice';
import { AuthToken } from '../../global/models/authenticated-model';
import { ProfileKey } from '../../pages/arc/constants/constant-strings';
import { ExternalLinkModal } from '../../global/components/external-link-modal';
import { getTcsmEpiProps } from '../../global/ducks/epi-api';


interface Props {
	navigation: Navigation,
	signInPath: string,
	signInText: string,
	siteSettingsId: string,
	currentCulture: string,
}

const onlyUnique = (value, index, self) => {
	return self.indexOf(value) === index;
};

const parseRoleNames = (data: any) => {
	if (!data || !data?.role_assignments) {
		return [];
	}
	const keys = Object.keys(data?.role_assignments);
	return Array.prototype.concat.apply([], keys?.map(key => data?.role_assignments[key].map(a => a?.role_name)));
};

export const CicNavWrapper = (props: Props) => {


	const { navigation, signInPath, signInText, siteSettingsId, currentCulture } = props;

	const { accessToken, decodedToken } = useContext(AuthContext) as any;

	const parsedGuid = (() => {
		if (decodedToken && decodedToken[ProfileKey]) {
			return (JSON.parse(decodedToken[ProfileKey]) as AuthToken)?.person?.guid;
		}
		return decodedToken;
	})();

	const dispatch = useDispatch();
	useEffect(() => {
		if (accessToken && decodedToken) {
			dispatch(setAccessToken(accessToken));
			dispatch(getRoles(
				parsedGuid,
				(res) => {
					const roles = parseRoleNames(res?.data)?.filter(onlyUnique);
					sessionStorage?.setItem('rolesMatrix', JSON.stringify(roles));
					dispatch(setRoles(roles));
					dispatch(setRoleObject(res?.data?.role_assignments || {}));
				},
			));
			dispatch(getApplications((res) => dispatchSetApplicationList(res, dispatch)));
			dispatch(getTcsmEpiProps(dispatch, siteSettingsId, { parsedGuid }, currentCulture, true));
			const signinEmail = document.getElementById('cpg-login-email');
			const signinEmailButton = document.getElementById('cpg-login-email-button');
			signinEmail?.setAttribute('disabled', 'true');
			signinEmailButton?.setAttribute('disabled', 'true');
			signinEmail?.setAttribute('placeholder', navigation?.LoggedInText || 'You are already signed in');
		}
	}, [accessToken, decodedToken]);



	if (!accessToken) {
		return <a href={signInPath} id='adage-sign-in-btn-nojs' className='btn-primary cpgms-main-header-utility-signin' >{signInText}</a >;

	}

	return (
		<CicAppContext.Provider value={CicAppKeys.ORG} >
			<CpgAppSelect navigation={navigation} />
			<ExternalLinkModal navigation={navigation} />
		</CicAppContext.Provider>

	);
};
